import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useUserRoleList(data = {}) {
  const { enabled = false, queryParams = '' } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getUserRoleList() {
    return privateFetch.get(`/v1/admin/roles${queryParams}`).then((res) => res.data);
  }

  return useQuery(['roles-lists', { data }], getUserRoleList, { enabled, keepPreviousData: true });
}

export default useUserRoleList;
